import { useMemo } from 'react';
import { v4 } from 'uuid';

/**
 * Hook that returns unique id which is persistent during whole component lifecycle
 */
export const useUniqueId = () => useMemo(v4, []);
